module.exports = __webpack_public_path__ + "static/img/home_case_05_zh.3365b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_case_05_zh.png
// module id = UHo0
// module chunks = 34